import React from 'react';
export const ProblemSection = () => {
  return <section className="py-10 md:py-16 px-6 md:px-10 bg-cream" data-id="element-223">
      <div className="max-w-4xl mx-auto" data-id="element-224">
        <h2 className="section-title text-center mb-8 md:mb-12" data-id="element-225">
          La realidad es esta:
        </h2>
        <p className="text-xl md:text-2xl text-center font-semibold mb-8 md:mb-12" data-id="element-226">
          Te convertiste en el sostén de todos… pero nadie te enseñó a
          sostenerte a ti.
        </p>
        <div className="mb-8 md:mb-12" data-id="element-227">
          <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-228">
            Para ti, que lo das todo cada día
          </h3>
          <ul className="space-y-4 serif-text text-lg" data-id="element-229">
            <li className="flex items-start" data-id="element-230">
              <span className="text-gold font-bold mr-2" data-id="element-231">•</span>
              <span data-id="element-232">
                Tú, que trabajas en servicio, retail, restaurantes, limpieza,
                cafeterías, supermercados o atención al cliente. Tú, que dices
                "yo me lo gano con sudor", porque así vives cada día.
              </span>
            </li>
            <li className="flex items-start" data-id="element-233">
              <span className="text-gold font-bold mr-2" data-id="element-234">•</span>
              <span data-id="element-235">
                Tú, que mandas remesas. Tú, que ayudas a tu mamá, a tus
                hermanos, a tus sobrinos. Tú, que cargas la presión silenciosa
                de ser "la fuerte".
              </span>
            </li>
            <li className="flex items-start" data-id="element-236">
              <span className="text-gold font-bold mr-2" data-id="element-237">•</span>
              <span data-id="element-238">
                Tú, que nunca descansas mentalmente. Tú, que vives apagando
                incendios. Tú, que sientes que estás atrapada en el mismo ciclo.
              </span>
            </li>
            <li className="flex items-start" data-id="element-239">
              <span className="text-gold font-bold mr-2" data-id="element-240">•</span>
              <span data-id="element-241">
                Trabajo → cansancio → quincena → pagos → nada sobrante →
                repetir.
              </span>
            </li>
            <li className="flex items-start" data-id="element-242">
              <span className="text-gold font-bold mr-2" data-id="element-243">•</span>
              <span data-id="element-244">
                Tú, que sientes culpa cuando te compras algo… y culpa cuando no
                te compras nada.
              </span>
            </li>
          </ul>
        </div>
        <div className="quote serif-text text-lg italic p-6 bg-white rounded-lg shadow-md" data-id="element-245">
          <p data-id="element-246">Esta carta es para ti.</p>
        </div>
      </div>
    </section>;
};